module.exports = __webpack_public_path__ + "img/faq.06e2a130.svg";